import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/salesCopy";
import { SectionHeader } from "./SectionHeader";
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="mx-auto max-w-3xl px-5 py-9 md:py-16" data-id="element-81" data-mp="1gd7fy6t1r74y">
      <SectionHeader eyebrow="DUDAS COMUNES" title="PREGUNTAS FRECUENTES" data-id="element-82" data-mp="1gauq77h1rshc" />
      <ul className="mt-4 space-y-2 md:mt-8" data-id="element-83" data-mp="2dzoeffdinqsa">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <li key={f.q} className={`rounded-xl ring-1 transition-colors duration-150 ease-out ${isOpen ? "bg-card ring-chalk" : "bg-card/60 ring-line"}`} data-id="element-84" data-mp="242a13omw3i47" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-chalk md:px-5 md:py-4 md:text-base" data-id="element-85" data-mp="1z2nit0s7fboj">
                {f.q}
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-chalk text-white" : "bg-chalk-soft text-chalk"}`} data-id="element-86" data-mp="ugiu4ydlhj8b">
                  <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="6rge1uylzyfx" />
                </span>
              </button>
              <AnimatePresence initial={false} data-id="element-88" data-mp="bhwsnie61q3v">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-89" data-mp="3syocedb4352g">
                    <p className="px-4 pb-4 text-[13px] leading-relaxed text-muted md:px-5 md:text-base" data-id="element-90" data-mp="3nyiggkxt6wek">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </section>;
}